// extracted by mini-css-extract-plugin
export default {"request__message":"ModalSupport_request__message__lMNL8","buttonOk":"ModalSupport_buttonOk__bTaqr"};